export const getCookieByName = (name: string): string | undefined => {
  const cookies = document.cookie.split("; ");

  for (const cookie of cookies) {
    const [cookieName, cookieValue] = cookie.split("=");
    if (cookieName === name) {
      return cookieValue;
    }
  }

  return undefined;
};

export const getUtmTerm = (): string | undefined => {
  return getCookieByName("wh_utm_term");
};

export const getUtmCampaign = (): string | undefined => {
  return getCookieByName("wh_utm_campaign");
};

export const hasAdwordsCookie = () => {
  const temp = getCookieByName("traffic-source");
  return temp === "adwords";
};
